import { css as _css } from "styled-components";
import { FlattenInterpolation as _FlattenInterpolation } from "styled-components";

/**
 * {@link styled-components#css} で生成した CSS を Props の型を考慮しつつ合成する
 * @param interpolations
 */
export var combineStyles = function combineStyles() {
  for (var _len = arguments.length, interpolations = new Array(_len), _key = 0; _key < _len; _key++) {
    interpolations[_key] = arguments[_key];
  }

  return _css(["", ""], interpolations);
};
//# sourceMappingURL=combineStyles.js.map